// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"676f95c7","980":"48e96b92"}[chunkId] + ".chunk.css";
};